import { component } from 'picoapp';
import breakItem from 'lib/collection-break-item';
import app from 'app';

const collection = component((node, ctx) => {
  const {
    blocks,
  } = node.dataset;

  const output = node.querySelector('[data-output]');
  const { handle } = node.parentElement.dataset;

  // Show error message if no matching products
  ctx.on('filter:rendered', () => {
    app.mount();

    const blocksData = JSON.parse(blocks);
    const relatedBlocks = blocksData.filter((item) => item.collection === handle);
    if (relatedBlocks) {
      const fragment = document.createDocumentFragment();

      relatedBlocks.forEach((block) => {
        const { position, image } = block;

        // Bail if no visual component
        if (!image) return;

        const className = 'collection__product';

        const el = document.createElement('div');
        el.className = `${className}`;
        el.innerHTML = breakItem(block, 'product-slider__item-hero');

        // Only render if amount of products exceeds selected positioning
        if (position <= output.children.length) {
          fragment.appendChild(el);
          output.insertBefore(fragment, output.children[position - 1]);
        }
      });
    }
  });
});

app.add({
  collection,
});

app.mount();
